export default function FilterButton(props) {
    const type = props.type;
    const showIconBadge = props.nrOfCheckedCheckboxes > 0 ? true : false
    const showMoreFilters = props.showMoreFilters

    return (
        <button id={`filterButton-${type}`} data-badge-number={showIconBadge ? props.nrOfCheckedCheckboxes : ''} className={`button-filter collapsed ${showMoreFilters ? '' : 'd-none'} ${showIconBadge ? 'button-icon icon-filter icon-badge' : ''}`} data-uu-target="more-filters" data-bs-toggle="collapse" data-bs-target={`#${type}`} aria-controls={type} aria-expanded="false"><span className="visually-hidden">Filtrera på </span>{props.buttonName}</button>
    );
}